<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().statusFilter.draft" (change)="onDraftToggled($event)">
        Draft
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().statusFilter.submitted" (change)="onSubmittedToggled($event)">
        In Progress
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().statusFilter.completed" (change)="onCompletedToggled($event)">
        Completed
    </mat-slide-toggle>
</div>
<ng-container *ngIf="getStateService().allStatusFiltersDisabled()">
    <div class="mt-2">
        <span style="color: red">*</span>&nbsp;<span class="text-muted">
            All filters inactive, <br />no claims will be displayed
        </span>
    </div>
</ng-container>